module.exports = __webpack_public_path__ + "img/peoples_icon.2f6ef2cf.svg";